export const parsePipedName = (
  pipedName: string,
  i18n: { language: string },
) => {
  if (!pipedName) return null;
  const nameArray = pipedName.split("|");
  const huName =
    `${nameArray[0]} ${nameArray[1]} ${nameArray[2]} ${nameArray[3]} ${nameArray[4]}`.trim();
  const enName =
    `${nameArray[2]} ${nameArray[3]} ${nameArray[1]} ${nameArray[4]}`.trim();
  return i18n.language === "hu" ? huName : enName;
};

export default parsePipedName;
